var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-bottom-navigation',{attrs:{"color":"primary","app":""}},_vm._l((_vm.routes),function(route){return _c('v-btn',{key:route.path,attrs:{"to":route.name,"value":route.name,"data-cy":route.name}},[_c('span',[_vm._v(_vm._s(route.text))]),_c('v-icon',[_vm._v(_vm._s(route.icon))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }